import { render } from "./logo.svg?vue&type=template&id=c989a428"
const script = {}
script.render = render

export default script